<!-- 企业级-业务领域-e站 -->
<template>
  <div class="mainArea CESite">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <el-tabs v-model="tabActive" @tab-click="tabChange" class="tabList" stretch>
          <el-tab-pane label="出入库查询" name="1">
            <cewarehoustquery v-if="tabActive=='1'"></cewarehoustquery>
          </el-tab-pane>
          <el-tab-pane label="配置信息" name="2">
            <ceconfigsetting v-if="tabActive=='2'"></ceconfigsetting>
          </el-tab-pane>
        </el-tabs>
      </div>
      
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../static/js/utility/utility.js"
  import ceconfigsetting from "../CESite/CEConfigSetting"
  import cewarehoustquery from "../CESite/CEWareHoustQuery"

  export default {
    name: 'CESite',
    components: {
      CBreadCrumb,
      ceconfigsetting,
      cewarehoustquery,
    },
    data() {
      return {
        tabActive:'1',
      };
    },
    mounted(){

    },
    created: async function () {
      
    },
    methods: {
      tabChange(tab, event){
        if(tab.index == 1){
          
        }else{
          
        }
      },
      
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      },
      
    }
  }
</script>

<style lang="scss">
.CESite{
  .tabList{
    width: 100%;
    // tabs标签
    .el-tabs__header {
      width: 100%;
      margin-bottom: 0;
      box-sizing: border-box;
      border-bottom: 1px solid #E4E7ED;
      .el-tabs__nav-wrap {
        padding-left: 20px;
        width: 360px;
      }
      .el-tabs__item {
        font-size: 18px;
      }
    }
  }
  .previewDio{
    .tr{
      text-align: right;
      el-button{
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border:1px solid #DCDFE6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img{
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
  }
  .el-table__expanded-cell{
    background: #f2f2f2;
    .bgTable{
      background: #f2f2f2;
    }
    &:hover{
      background-color: #f2f2f2 !important;
    }
    .el-table--enable-row-hover .el-table__body tr:hover>td{
      background-color: #f2f2f2;
    }
  }
  
  .dib{
    display:inline-block;
  }
  .db{
    display:block;
  }
  .contDio{
    .el-select{ display:block;}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CAuthorizationManage/CESite.vue